import { ProfileModel } from 'src/app/domain/models/profile.model';
import { AppState } from '../states/app.state';

export const getProfile$ = (appState: AppState): ProfileModel =>
    appState.profile.profile;
